export var socialNetworkNameReplacement = {
  facebook: 'facebook',
  twitter: 'twitter',
  whatsapp: 'whatsapp',
  share: 'mail'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-share-buttons/es/socialNetworkNameReplacement.js
// module id = null
// module chunks = 